import React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MoreVertIcon from '@material-ui/icons/MoreVert';


@observer
class MoreMenu extends React.Component {
  @observable anchorEl = null;

  get open() {
    return Boolean(this.anchorEl);
  }

  onOpen = event => {
    this.anchorEl = event.currentTarget;
  };

  onClose = () => {
    this.anchorEl = null;
  };

  render() {
    const { children } = this.props;
    return (
      <>
        <IconButton onClick={this.onOpen}>
          <MoreVertIcon />
        </IconButton>
        <Menu open={this.open} anchorEl={this.anchorEl} onClose={this.onClose}>
          {children}
        </Menu>
      </>
    );
  }
}


export default MoreMenu;
